import { Header } from "./Header";
import { SortableTableHead } from "./SortableTableHead";

export interface SortableHeadProps {
  className?: string;
}

export const SortableHead = ({ className }: SortableHeadProps) => (
  <Header
    className={className}
    renderHeader={({ header }) => (
      <SortableTableHead key={header.id} header={header} />
    )}
  />
);
